import { render, staticRenderFns } from "./ServicesOfferts.vue?vue&type=template&id=7c846c4b"
import script from "./ServicesOfferts.vue?vue&type=script&lang=js"
export * from "./ServicesOfferts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports